<template>
    <header class="slider widtr" style="height:auto!important">
        <div class="main-slider">
            <swiper :speed="500" :parallax="true" :centeredSlides="true" :watchSlidesProgress="true" :autoplay="{
                delay: 5000,
                disableOnInteraction: false,
            }" :allowSlideNext="true" :pagination=paginat :modules="modules">
                <!-- <div class="swiper-wrapper"> -->
                <swiper-slide v-for="item in banners" :key="item.ban_name">
                    <div class="slide-inner bg-image"
                        :style="{ 'background-image': 'url(' + uploadPath + item.ban_name + ')' }">
                        <div class="container" data-swiper-parallax="200">
                            <h6 class="tagline" style="font-size: 10px;
font-weight: 600;">{{item.ban_lang}} </h6>
                            <h2 class="name" style="font-size: 20px;">{{ item.ban_text }} <br>
                                <strong style="font-size: 20px;"> {{ item.ban_tag }}
                                </strong>
                            </h2>


                            <!-- <a href="https://hilitebuilders.com/hilite-business-park-office-commercial-spaces-in-calicut/"
                                target="_blank" class="play-btn" style="height: 39px;
line-height: 39px;">More Details</a> -->
                        </div>
                        <!-- end container -->
                    </div>
                    <!-- end slide-inner -->
                </swiper-slide>
            </swiper>
            <!-- </div> -->
            <!-- end swiper-wrapper -->
            <div class="swiper-pagination"></div>
            <!-- end swiper-pagination -->
        </div>
        <!-- end main-slider -->
    </header>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import venobox from "venobox";

import { Autoplay, Pagination, Navigation } from 'swiper';
import axios from 'axios';
import { URL, UPLOADS } from '@/conf.js';
export default {
    data() {
        return {
            myswiper: null,
            uploadPath: UPLOADS,
            imgPath: process.env.BASE_URL,
            result: null,
            banners: null,
            modules: [Autoplay, Pagination, Navigation],
            loaded: false,
            paginat: {
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><circle r="13" cy="15" cx="15"></circle></svg></span>';
                },
            },


        };
    },
    components: {
        SwiperSlide,
        Swiper
    },
    methods: {
        async getBanners() {
            new venobox();
            axios.get(URL + 'banners')
                .then(response => {
                    this.loaded = true;
                    this.result = response.data;
                    const resultarr = this.result.response.result
                    this.banners = resultarr;

                })
        },

    },
    mounted() {
        this.getBanners();
    },


};
</script>
<style>
@import 'swiper/css';
@import 'swiper/css/pagination';
@import 'swiper/css/navigation';
</style>